<script lang="ts" setup>
	import AvailabilityOverviewTable from '@/components/AvailabilityOverviewTable.vue';
	import {useAvailability} from '@/store/availability.store';
	import {useRegionStore} from '@/store/region.store';
	import {computed, onMounted} from 'vue';
	import OverviewWrapper from '@/views/OverviewWrapper.vue';

	const availabilityStore = useAvailability();

	const numberOfResults = computed(() => availabilityStore.numberOfResults);

	const getResult = async () => await availabilityStore.getAvailabilityResult();

	onMounted(async () => {
		await useRegionStore().loadRegions();
		await getResult();
	});
</script>

<template>
	<OverviewWrapper :number-of-results="numberOfResults" @update-overview="getResult">
		<AvailabilityOverviewTable />
	</OverviewWrapper>
</template>
